/* Scoped storefront improvements. Existing variant/cart/advisor controllers remain authoritative. */
(() => {
  'use strict';
  const isJa = !document.documentElement.lang.toLowerCase().startsWith('en');
  const ready = fn => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, {once:true}) : fn();
  const money = variant => variant.priceText;
  const syncCategoryLink = a => {
    const url = new URL(a.href), current = new URL(location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.') || ['sort_by','page','preview_theme_id'].includes(key)) url.searchParams.delete(key);
    }
    current.searchParams.forEach((value,key)=>{if(key.startsWith('filter.') || ['sort_by','preview_theme_id'].includes(key))url.searchParams.append(key,value);});
    a.href = url.toString();
  };
  const setupProduct = root => {
    if (!root.ready || root.dataset.londaFlowReady) return;
    const purchase = root.querySelector('[data-lpd-purchase-home]');
    const help = root.querySelector('.lpd-help-links');
    if (!purchase || !help) return;
    root.dataset.londaFlowReady = 'true';
    const anchor = document.createComment('Original desktop purchase position');
    purchase.before(anchor);
    const guide = root.querySelector('.londa-buy-help__guide[data-lpd-open-size]');
    const guideAnchor = document.createComment('Original size-guide position');
    if (guide) guide.before(guideAnchor);
    const mobile = matchMedia('(max-width: 989px)');
    const arrange = () => {
      if (mobile.matches) {
        // Keep the description before size/color choices on mobile as on desktop.
        anchor.after(purchase);
        if (guide) purchase.prepend(guide);
      } else {
        anchor.after(purchase);
        if (guide) guideAnchor.after(guide);
      }
    };
    arrange();
    mobile.addEventListener('change',arrange,{signal:root.signal});
    // Series prices are read from the existing product payload, never inferred from photos.
    const variants = root.data.variants || [];
    const styleIndex = root.data.options.findIndex(name=>/style|スタイル|デザイン/i.test(name));
    if (/series/i.test(root.data.title) && styleIndex >= 0 && !variants.some(v=>/^JA-?327(?:[^0-9]|$)/i.test(v.sku))) {
      const styles = [...new Set(variants.map(v=>v.options[styleIndex]))];
      if(styles.length>1) {
        const note=document.createElement('div');
        note.className='londa-series-prices';
        const caption=document.createElement('p');
        caption.textContent=isJa?'表示価格は選択した種類の価格です。ご注文の種類・サイズをご確認ください。':'The displayed price is for the selected item. Please check its style and size.';
        note.append(caption);
        const list=document.createElement('ul');
        for(const name of styles){
          const choices=variants.filter(v=>v.options[styleIndex]===name).sort((a,b)=>a.price-b.price);
          const li=document.createElement('li');
          li.textContent=name+' '+money(choices[0])+(choices.some(v=>v.price!==choices[0].price)?'〜':'');
          list.append(li);
        }
        note.append(list);
        root.querySelector('.lpd-price')?.after(note);
      }
    }
  };
  ready(() => {
    // Header navigation and old inbound links share the same canonical destination.
    document.querySelectorAll('a[href*="/pages/style-group-1"]').forEach(a=>a.href=a.href.replace('/pages/style-group-1','/pages/style-group'));
    document.querySelectorAll('[data-londa-style-category]').forEach(syncCategoryLink);
    // Filters update the URL without a page load. Read the current conditions at activation.
    for (const eventName of ['pointerdown','focusin','click']) document.addEventListener(eventName,event=>{
      const a=event.target.closest?.('a[data-londa-style-category]');
      if(a)syncCategoryLink(a);
    },true);
    if(document.querySelector('londa-product')) customElements.whenDefined('londa-product').then(()=>{
      const P=customElements.get('londa-product').prototype;
      if(!P.londaPurchaseFlow){
        P.londaPurchaseFlow=true;
        const refine=P.refineV3;
        P.refineV3=function(){const result=refine?.apply(this,arguments);setupProduct(this);return result;};
      }
      document.querySelectorAll('londa-product').forEach(setupProduct);
    });
    if(!location.pathname.includes('/apps/page/wishlist'))return;
    const main=document.querySelector('main');
    if(!main)return;
    const update=()=>{
      const page=main.querySelector('.Vtl-WishlistPage');
      if(!page)return;
      page.querySelector('.Vtl-WishlistPage__Title')?.classList.add('londa-wishlist-page-title');
      page.querySelector('.Vtl-WishlistPage__ShareToolbar')?.classList.add('londa-wishlist-share-row');
      const empty=page.querySelector('.Vtl-WishlistPage__EmptyList');
      if(empty && !empty.dataset.londaEmpty){
        empty.dataset.londaEmpty='true';
        const message=empty.querySelector('.Vtl-WishlistPage__EmptyMessage');
        if(message)message.textContent=isJa?'気になる商品をハートで保存すると、ここに表示されます。':'Save items with the heart button to see them here.';
        const links=document.createElement('div');links.className='londa-empty-actions';
        for(const [url,label] of [['/collections/hot-items',isJa?'人気商品を見る':'Shop popular items'],['/collections/women',isJa?'カテゴリーから探す':'Shop by category']]){
          const a=document.createElement('a');a.href=url;a.className='btn';a.textContent=label;links.append(a);
        }
        empty.append(links);
      }
    };
    update();
    let queued=false;
    new MutationObserver(()=>{
      if(queued)return;queued=true;
      requestAnimationFrame(()=>{queued=false;update();});
    }).observe(main,{childList:true,subtree:true});
  });
})();
